import Vue from 'vue';
import App from './App.vue';
import router from './router/index';
import axios from 'axios'
import {CreateElement, VNode} from 'vue/types/umd';
import BootstrapVue from 'bootstrap-vue'
import 'bootstrap/dist/css/bootstrap.css'
import 'bootstrap-vue/dist/bootstrap-vue.css'

Vue.use(BootstrapVue);
Vue.prototype.$axios = axios;
Vue.config.productionTip = false;

new Vue({
  router,
  render: (h: CreateElement): VNode => h(App),
}).$mount('#app');
